// src/components/ui/LogoSociete.tsx — SCE Issues
// Le logo d'une société (29/10), à la hauteur demandée, proportions gardées.
// Rien tant qu'il n'est pas lu, ni sans logo : le nom, à côté, suffit toujours.
// Lu par Graph et gardé en cache (api/logosSocietes) : jamais de <img> vers
// SharePoint.

import { useEffect, useState } from 'react'
import { lireLogo } from '@/api/logosSocietes.api'

export function useLogoSociete(id: string | null | undefined): string | null {
  const [url, setUrl] = useState<string | null>(null)
  useEffect(() => {
    setUrl(null)
    if (!id) return
    let actif = true
    void lireLogo(id).then((u) => actif && setUrl(u))
    return () => {
      actif = false
    }
  }, [id])
  return url
}

export function LogoSociete({ id, hauteur, largeurMax }: { id: string | null | undefined; hauteur: number; largeurMax?: number }): JSX.Element | null {
  const url = useLogoSociete(id)
  if (!url) return null
  return (
    <img
      src={url}
      alt=""
      aria-hidden="true"
      style={{ display: 'block', height: hauteur, width: 'auto', maxWidth: largeurMax ?? hauteur * 4, objectFit: 'contain', flexShrink: 0 }}
    />
  )
}
